import React from 'react';
import { useQuery } from '@apollo/client';
import { useHistory, useLocation, Link as RouterLink } from 'react-router-dom';
import { useBackendUserState } from 'contexts/UserContext';
import {
  Box, Typography, Dialog, DialogContent, Button,
  Grid,
  Link,
} from '@material-ui/core';
import {
  closeAll,
} from 'actions/authDialogActions';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import DialogTitle from 'shared/components/DialogTitle';
import { GET_ROTATION_ACTION_NEEDED } from 'shared/queries/rotation/queries';
import paths from 'paths';
import { useSigninCheck } from 'reactfire';

const RotationDialog = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const { data: signInCheckResult } = useSigninCheck();
  const isUserAuthenticated = signInCheckResult.signedIn;

  const isHasConfirmRotationOpen = useSelector(state => state.authDialogsState.isHasConfirmRotationOpen, shallowEqual);

  const { data: { rotationWithRequiredActions = {} } = {} } = useQuery(
    GET_ROTATION_ACTION_NEEDED, {
      skip: !isUserAuthenticated,
      fetchPolicy: 'cache-and-network',
    },
  );
  const { state: { user: backendUser } } = useBackendUserState();

  const handleClose = () => {
    dispatch(closeAll());
  };

  const isDialogOpen = isHasConfirmRotationOpen && rotationWithRequiredActions?.uuid && backendUser
  && !location.pathname.includes(rotationWithRequiredActions?.uuid);

  const handleRequestPreceptorClick = event => {
    event.stopPropagation();
    history.push(paths.rotationPaths.rotationReservationPayment.reverse({ uuid: rotationWithRequiredActions?.uuid }));
  };

  return (
    <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={isDialogOpen}>
      <Box mb={2}>
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Confirm Rotation
        </DialogTitle>
      </Box>
      <DialogContent>
        <Typography variant="subtitle2" color="textSecondary">
          A new Preceptor has been added to your rotation
          {' '}
          <Link
            component={RouterLink}
            to={paths.rotationPaths.rotationAllPreceptors.reverse({ uuid: rotationWithRequiredActions?.uuid || 'default' })}
          >
            {rotationWithRequiredActions?.uid}
          </Link>
          .
          Please complete the reservation to proceed.
          You can still delete this rotation before reserving
          a preceptor on the “My Rotations” page.
        </Typography>

        <Box my={3}>
          <Grid container direction="row" alignItems="center" justify="space-between">
            <Grid item xs={5} sm={4}>
              <Button variant="outlined" size="large" fullWidth onClick={() => dispatch(closeAll())}>
                Cancel
              </Button>
            </Grid>
            <Grid item xs={5} sm={4}>
              <Button variant="contained" size="large" fullWidth type="submit" onClick={handleRequestPreceptorClick}>
                Reserve Preceptor
              </Button>
            </Grid>
          </Grid>
        </Box>

      </DialogContent>
    </Dialog>
  );
};

export default RotationDialog;
